import loadable from '@loadable/component';

export const AuthUserInvitePageLoadable = loadable(
  () => import('./AuthUserInvitePage'),
  { resolveComponent: (module) => module.AuthUserInvitePage },
);
